import { forwardRef, type SVGProps } from 'react';

export type TextFieldIconProps = Omit<SVGProps<SVGSVGElement>, 'css'>;

export const TextFieldIcon = forwardRef<SVGSVGElement, TextFieldIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 20 20">
    <path
      d="M11.644 5.256H8.18v10.107a.94.94 0 0 1-.218.625.8.8 0 0 1-.625.256.8.8 0 0 1-.625-.256.94.94 0 0 1-.22-.625V5.256h-3.55a.73.73 0 0 1-.53-.219.69.69 0 0 1-.225-.524.74.74 0 0 1 .218-.538.76.76 0 0 1 .556-.225h8.67a.78.78 0 0 1 .556.225.73.73 0 0 1 .23.538.69.69 0 0 1-.224.524.76.76 0 0 1-.55.22m5.362 9.332a.63.63 0 0 0-.444-.182 1.5 1.5 0 0 0-.537.169 1.75 1.75 0 0 1-.75.156 1.6 1.6 0 0 1-.513-.075.63.63 0 0 1-.33-.262 4 4 0 0 1-.22-.363 1.3 1.3 0 0 1-.1-.475q0-.35-.037-.525V9.775h1.969a.725.725 0 0 0 .725-.719.69.69 0 0 0-.213-.5.7.7 0 0 0-.512-.218h-1.975v-1.35a.68.68 0 0 0-.175-.488.66.66 0 0 0-.5-.194q-.508-.001-.744.625a7 7 0 0 0-.219 1.413h-.787a.75.75 0 0 0-.684.44.71.71 0 0 0 .165.797c.142.13.327.2.519.2h.762v2.957c0 2.337.919 3.518 2.731 3.518a2.56 2.56 0 0 0 1.813-.556.88.88 0 0 0 .238-.625.68.68 0 0 0-.182-.487"
      fill="currentColor"
    />
  </svg>
));

TextFieldIcon.displayName = 'TextFieldIcon';
